import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { TPAComponentsConsumer, TextButton } from 'wix-ui-tpa';
import { Divider } from './Divider';
import { st, classes } from './EmptyState.st.css';
import { connect } from '../../../common/components/runtime-context';
import settingsParams from '../settingsParams';
import { RootState } from '../state';
import { IActionCreators } from '../../../types/internal-types';

type RuntimeProps = ReturnType<typeof mapRuntimeToProps>;

interface Props {
  ppInstalled: boolean;
}

const EmptyState = ({ ppInstalled, navigateToPricingPlans }: Props & RuntimeProps) => {
  const settings = useSettings();
  return (
    <TPAComponentsConsumer>
      {({ mobile }) => (
        <div className={st(classes.root, mobile ? { mobile } : undefined)} data-hook="empty-state">
          {!mobile && <Divider />}
          <div className={classes.content}>
            <p className={classes.noSubscriptionText}>{settings.get(settingsParams.noSubscriptionText)}</p>
            {ppInstalled && (
              <TextButton className={classes.cta} onClick={() => navigateToPricingPlans()({ emptyState: true })}>
                {settings.get(settingsParams.pricingPlansLinkText)}
              </TextButton>
            )}
          </div>
          {!mobile && <Divider />}
        </div>
      )}
    </TPAComponentsConsumer>
  );
};

const mapRuntimeToProps = (_: RootState, __: Props, { navigateToPricingPlans }: IActionCreators) => ({
  navigateToPricingPlans,
});

export default connect(mapRuntimeToProps)(EmptyState);
